<form [formGroup]="quoteInfoForm">
  <div class="wrapper row pad-horizontal-10">
    <div class="column twelve md-eight">
      <div
        class="pad-top-20 margin-bottom-20 pad-horizontal-10 row column twelve lg-push-one md-eleven md-push-one"
      >
        <h2
          dsContent
          [contentPath]="'policy.addVehicleCustomizeCoverageHeader'"
          class="bold-header"
        ></h2>
        <div class="margin-bottom-10">
          <p>{{ currentVehicleRiskDescriptionInfoMessage$ | async }}</p>
        </div>
        <div
          class="pad-bottom-60"
          dsContent
          [contentPath]="'policy.addVehicleCustomizeCoverageInfoPart2'"
        ></div>
        @if (
          (
            ((isPartner$ | async) ? vehicleCoveragesFacade.coverages$ : this.vehicleCoverages$)
            | async
          )?.length
        ) {
          <div class="margin-bottom-80 card-margin-bottom">
            <ds-out-of-pocket-coverages
              [coverages]="vehicleCoverages$ | async"
              [partnerCoverages]="vehicleCoveragesFacade.coverages$ | async"
              [form]="quoteInfoForm"
              [sectionHeader]="deductibleHeader$ | async"
              [vehicleRiskDescription]="vehicleRiskDescriptionWithoutSeries$ | async"
              [state]="userState$ | async"
              [isPartner]="isPartner$ | async"
              (updateCoverage)="vehicleCoveragesFacade.updateCoverage($event)"
              [selectedId]="vehicleCoveragesFacade.selectedId$ | async"
            ></ds-out-of-pocket-coverages>
          </div>
        }
        @if (!!(policyCoverages$ | async)?.coverages?.length) {
          <div class="margin-top-80 card-margin-bottom">
            <ds-included-coverages
              [coverages]="policyCoverages$ | async"
              [sectionHeader]="includedCoveragesHeader"
            >
            </ds-included-coverages>
          </div>
        }
        @if (
          (
            ((isPartner$ | async)
              ? vehicleAppliedDiscountsNamePartner$
              : vehicleAppliedDiscountsName$
            ) | async
          )?.length
        ) {
          <div class="margin-top-80 card-margin-bottom">
            <ds-included-discounts-list
              [isPartner]="isPartner$ | async"
              [discountList]="
                ((isPartner$ | async)
                  ? vehicleAppliedDiscountsNamePartner$
                  : vehicleAppliedDiscountsName$
                ) | async
              "
              [sectionHeader]="discountsHeader"
            ></ds-included-discounts-list>
          </div>
        }
        <blockquote class="border -primary-800 caption">
          @if (hasAntiTheftDiscount$ | async) {
            <div
              dsContent
              [contentPath]="'policy.antiTheftDiscountDisclaimer'"
              class="margin-bottom-10"
            ></div>
          }
          <div dsContent [contentPath]="'policy.addVehicleDisclaimer1'"></div>
        </blockquote>
      </div>
    </div>
    <!-- <button (click)="saveAndRate()">save-and-rate</button> -->
    @if (
      !!(((isPartner$ | async) ? quoteDataForSideBarPartner$ : quoteDataForSideBar$) | async)
        ?.quoteTotalAmount && !!(currentVehicleRiskDescription$ | async)
    ) {
      <div class="sidebar column twelve md-four">
        <ds-quote-sidebar
          [noOfVehicles]="noOfVehicles$ | async"
          [icons]="icons$ | async"
          [quoteData]="
            ((isPartner$ | async) ? quoteDataForSideBarPartner$ : quoteDataForSideBar$) | async
          "
          [vehicleName]="currentVehicleRiskDescription$ | async"
          [needRecalculation]="needRecalculation$ | async"
          [showResetCoverageButton]="showResetCoverageButton$ | async"
          (recalculateQuote)="recalculateQuote()"
          (resetQuote)="reset()"
        ></ds-quote-sidebar>
      </div>
    }
  </div>
  <div class="column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="'Continue'"
      (primaryEvent)="nextStep()"
      [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
      (secondaryEvent)="notifyAgentEvent.emit({ isProcessExited: true })"
      [disableSecondaryButton]="(authorized$ | async) !== true"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>
